export class ModalConfirmacaoEnderecoColetaController implements angular.IController {
  constructor($scope, $uibModalInstance) {
    $scope.confirmar = () => {
      $uibModalInstance.close({});
    };

    $scope.cancelar = () => {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
